var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 81,
    viewBox: "0 0 41 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "15997 [Converted]-02 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.14415 53.3834C7.84356 54.0045 6.67835 56.604 7.84356 58.603C9.00877 60.6021 12.1917 60.9358 13.5375 60.6244C14.2998 58.8473 13.9806 57.4885 13.9806 57.4885L9.14254 53.3818L9.14415 53.3834Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9821 57.49L9.14395 53.3833C7.55165 54.3158 8.71042 55.946 9.8724 57.0541C11.1279 58.2516 12.6122 59.307 12.8169 60.7153C13.0876 60.7009 13.3342 60.6706 13.5373 60.6243C14.2996 58.8472 13.9804 57.49 13.9804 57.49H13.9821Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.657 44.8541C9.68437 46.1874 8.12432 48.4531 8.15977 51.3399C8.18878 53.7589 10.5353 57.2045 13.5394 58.2695C15.2445 55.5152 15.1446 53.2431 15.1446 53.2431L11.657 44.8525V44.8541Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1428 53.2431L11.6553 44.8525C11.0155 45.2852 10.4208 45.8169 9.90826 46.4349C8.62863 49.8502 13.7069 53.382 12.7915 57.9438C13.0348 58.0667 13.283 58.1785 13.5377 58.2695C15.2428 55.5152 15.1428 53.2431 15.1428 53.2431Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.4672 40.7667C14.2568 41.1659 11.4768 42.4991 11.1625 45.164C10.8482 47.8289 13.1803 52.6716 14.8838 53.8708C16.8564 49.6954 15.4672 40.7651 15.4672 40.7651V40.7667Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4668 40.7667C15.0397 40.9072 14.4176 41.1675 13.7762 41.5587C13.4668 41.9148 13.3072 42.2389 13.1348 42.7211C11.9293 46.0869 14.7496 47.8528 14.0421 53.0517C14.3306 53.3997 14.6142 53.6823 14.885 53.8708C16.8576 49.6954 15.4684 40.7651 15.4684 40.7651L15.4668 40.7667Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.0859 45.8871C30.0859 49.4748 27.828 52.384 25.0415 52.384C22.255 52.384 19.9971 49.4748 19.9971 45.8871C19.9971 42.2993 22.2566 39.3901 25.0415 39.3901C27.8264 39.3901 30.0859 42.2993 30.0859 45.8871Z",
    fill: "#EDAA89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.1093 56.1427C12.1278 60.2813 11.8812 63.1122 12.1939 66.4445C12.5082 69.7768 14.7048 77.8177 16.4083 78.7949L31.3385 78.3957C32.0814 77.6197 30.394 72.0345 31.5206 67.1119C32.5069 62.8025 34.9276 57.9597 36.2281 54.5843C37.5287 51.2089 38.0122 48.94 37.8865 46.5434C37.7076 43.1233 34.4779 33.8816 32.1475 30.1055C29.5915 34.0158 29.2772 42.855 29.2772 42.855C25.8686 44.6321 23.493 49.3855 22.9999 50.8512C16.2745 54.7599 13.1077 56.1427 13.1077 56.1427H13.1093Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.5201 67.1105C32.5064 62.801 34.9271 57.9582 36.2277 54.5828C37.5283 51.2074 38.0118 48.9385 37.8861 46.5419C37.7072 43.1218 34.4775 33.8802 32.1471 30.104C31.6378 30.8816 31.2188 31.8572 30.8739 32.9174C32.8207 38.0715 34.6676 43.2112 34.2551 47.3307C33.7168 52.6955 30.2195 58.2472 28.9415 63.3119C28.1615 66.4031 27.1075 72.4673 28.3065 78.4757L31.338 78.3942C32.081 77.6183 30.3936 72.033 31.5201 67.1105Z",
    fill: "#EDAA89"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.5947 2.20654H2.2832V44.4374H32.5947V2.20654Z",
    fill: "#EE1300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.5964 44.4358H2.2832C19.5373 37.4854 29.0185 22.7895 32.5964 2.20654V44.4358Z",
    fill: "#D01300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.6455 52.3171C25.1072 48.7182 23.0218 46.9857 22.4835 43.9201C21.9452 40.8545 22.282 37.0559 20.1966 34.5252C18.1111 31.9928 15.489 31.9258 14.7476 32.7928C14.0079 33.6598 15.0845 39.4574 15.2859 44.0542C15.4874 48.6527 13.8741 52.9174 12.999 56.5818L25.6439 52.3171H25.6455Z",
    fill: "#FDC8A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.1979 34.5252C18.1125 31.9928 15.4904 31.9258 14.749 32.7928C17.1246 33.0594 18.5154 34.6912 19.6258 37.8575C20.6299 40.7219 19.8837 43.8546 21.542 47.3194C22.5493 49.4239 24.2512 50.0626 25.2826 52.44C24.7444 48.8411 22.8652 47.0081 22.3269 43.9441C21.7886 40.8784 22.2818 37.0591 20.1963 34.5268L20.1979 34.5252Z",
    fill: "#EDAA89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/red-card.a6f36eb675fddf0def3e686ea59e026a.svg";
export { ForwardRef as ReactComponent };